import { render, staticRenderFns } from "./goodsShop.vue?vue&type=template&id=2f0cf6bc&scoped=true&"
import script from "./goodsShop.vue?vue&type=script&lang=js&"
export * from "./goodsShop.vue?vue&type=script&lang=js&"
import style0 from "./goodsShop.vue?vue&type=style&index=0&id=2f0cf6bc&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cf6bc",
  null
  
)

export default component.exports